import React, { useState, ChangeEvent, useEffect } from 'react'
import {
  NumberInput,
  NumberInputField,
  NumberInputStepper,
  NumberIncrementStepper,
  NumberDecrementStepper
} from '@rockr/rock-ui'
import { mountEvent } from '../../shared/helpers/input'

type Props = {
  name: string
  placeholder?: string
  value?: string | number
  onChange?: (e: ChangeEvent<any>) => any
  customFormat?: (value: string | number) => string | number
  min?: number
  max?: number
  disabled?: boolean
  textAlign?: 'left' | 'center' | 'right'
  isInvalid?: boolean
}

export const IntegerInput: React.FC<Props> = ({
  name,
  placeholder,
  value: defaultValue,
  onChange,
  customFormat,
  min,
  max,
  disabled,
  textAlign='left',
  isInvalid
}) => {
  const formatted = customFormat?.(defaultValue!)
  const [value, setValue] = useState(formatted || defaultValue)

  const getValueToUpdate = (rawValue: number) => {
    if (max && rawValue > max) {
      return max
    }

    if (min && rawValue < min) {
      return min
    }

    return rawValue
  }

  const handleInputChange = (
    valueAsString: string
  ) => {
    const valueAsNumber = Number(valueAsString.replace(/\D+/g, ''))
    const valueToUpdate = getValueToUpdate(valueAsNumber)
    const customFormatted = customFormat?.(valueToUpdate)
    const rawEvent = mountEvent(name, Number(valueToUpdate))
    const newValue = Math.round(Number(customFormatted || valueToUpdate))

    setValue(isNaN(newValue) ? 0 : newValue)
    onChange?.(rawEvent as ChangeEvent<any>)
  }

  useEffect(() => {
    if (defaultValue) {
      const rawEvent = mountEvent(name, defaultValue)
      setValue(defaultValue)
      onChange?.(rawEvent as ChangeEvent<any>)
    }
    // eslint-disable-next-line
  }, [defaultValue])

  return (
    <NumberInput
      placeholder={placeholder}
      isDisabled={disabled}
      isInvalid={isInvalid}
      value={value}
      onChange={handleInputChange}
      textAlign={textAlign}
    >
      <NumberInputField />
      <NumberInputStepper>
        <NumberIncrementStepper />
        <NumberDecrementStepper />
      </NumberInputStepper>
    </NumberInput>
  )
}
